import { useQuery } from '@tanstack/react-query';
import { queryFetch } from '@services/api';
import { ApiError } from '@root/globalTypes';
import { queryKeys } from '@utils/consts';
import { useAppContext } from '@contexts/app';
import { PanelDropdownRespSuccess } from '../types';
import { usePanel } from '@hooks/usePanel';

export const usePanelZonesDropdown = () => {
  const {
    admin: { isLogged },
  } = useAppContext();

  const { panel } = usePanel();

  const { data, error, isFetching } = useQuery<PanelDropdownRespSuccess, ApiError>({
    queryKey: queryKeys.dropdowns.panel.zones,
    queryFn: () => queryFetch({ url: 'dropdowns/zones', panel }),
    placeholderData: (previousData) => previousData as PanelDropdownRespSuccess,
    enabled: isLogged && panel,
  });

  return {
    data,
    error,
    isLoading: isFetching,
  };
};
